<script setup lang="ts">
import { useVersionStore } from '@/store/modules/version';
import { $t } from '@/locales';

defineOptions({
  name: 'GlobalLogo'
});

interface Props {
  /** Whether to show the title */
  showTitle?: boolean;
}

withDefaults(defineProps<Props>(), {
  showTitle: true
});

const versionStore = useVersionStore();
</script>

<template>
  <RouterLink to="/" class="w-full flex-center nowrap-hidden">
    <SystemLogo class="text-32px text-primary" />
    <h2 v-show="showTitle" class="pl-8px text-16px text-primary font-bold transition duration-300 ease-in-out">
      {{ $t('system.title') }}
      <!-- <div class="text-10px text-gray-400 mt-1px">{{ versionStore.isBaseVersion ? '基地版' : '非基地版' }}</div> -->
    </h2>
  </RouterLink>
</template>

<style scoped></style>
